import "../css/app.css"

const list = document.querySelector("#orders-list")
const refresh = document.querySelector("#refresh-orders")
const status = document.querySelector("#orders-status")
const search = document.querySelector("#orders-search-input")
const empty = document.querySelector("#orders-empty")
let orders = []

const text = (tag, value, className) => {
  const element = document.createElement(tag)
  element.textContent = value ?? ""
  if (className) element.className = className
  return element
}

const dataCell = (value, className, label) => {
  const cell = text("td", value, className)
  cell.dataset.label = label
  return cell
}

const searchableText = (order) => {
  const customer = order.customer ? `${order.customer.first_name || ""} ${order.customer.last_name || ""}`.trim() : ""
  const address = order.shipping_address?.address1 || ""
  const pickupLabel = order.pick_up ? "PICK-UP" : ""
  return [order.name, order.order_number, customer, order.email, address, order.zone, pickupLabel]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
}

const reprint = async (order) => {
  const response = await fetch(`/orders/${encodeURIComponent(order.id)}/reprint`, {
    method: "POST",
    headers: {"Accept": "application/json"}
  })
  if (!response.ok) throw new Error(`Reprint request failed (${response.status})`)
  status.textContent = `Order ${order.name || `#${order.order_number}`} queued for printing.`
}

const renderOrder = (order) => {
  const row = document.createElement("tr")
  const address = order.shipping_address?.address1 || "Brewery pick up"
  const quantity = (order.line_items || []).reduce((sum, item) => sum + Number(item.quantity || 0), 0)
  const date = order.created_at ? new Intl.DateTimeFormat("en-NZ", {dateStyle: "medium", timeStyle: "short"}).format(new Date(order.created_at)) : ""

  const linkCell = document.createElement("td")
  const link = text("a", order.name || `#${order.order_number}`)
  link.href = `https://${document.body.dataset.shopDomain || "brewaucracy.myshopify.com"}/admin/orders/${order.id}`
  link.target = "_blank"
  link.rel = "noreferrer"
  linkCell.append(link)
  linkCell.className = "order-cell order-cell--identity"
  linkCell.dataset.label = "ID"

  row.append(
    linkCell,
    dataCell(date, "order-cell order-cell--date", "Ordered"),
    dataCell(order.customer ? `${order.customer.first_name || ""} ${order.customer.last_name || ""}`.trim() : "", "order-cell order-cell--customer", "Name"),
    dataCell(order.email, "order-cell order-cell--email", "Email"),
    dataCell(address, "order-cell order-cell--address", "Address"),
    dataCell(order.pick_up ? "PICK-UP" : order.zone, "order-cell order-cell--zone", "Zone"),
    dataCell(`${quantity}x`, "order-cell order-cell--quantity", "Riggers"),
    dataCell(order.docket_printed ? "Yes" : "No", `order-cell order-cell--docket ${order.docket_printed ? "printed" : "pending"}`, "Docket"),
    dataCell(order.labels_printed ? "Yes" : "No", `order-cell order-cell--labels ${order.labels_printed ? "printed" : "pending"}`, "Labels")
  )

  const actionCell = document.createElement("td")
  const button = text("button", "Reprint")
  button.type = "button"
  button.addEventListener("click", async () => {
    button.disabled = true
    try { await reprint(order) }
    catch (error) { status.textContent = error.message }
    finally { button.disabled = false }
  })
  actionCell.append(button)
  actionCell.className = "order-cell order-cell--actions"
  actionCell.dataset.label = "Actions"
  row.append(actionCell)
  return row
}

const renderOrders = () => {
  const query = search?.value.trim().toLowerCase() || ""
  const matchingOrders = orders.filter((order) => searchableText(order).includes(query))
  list.replaceChildren(...matchingOrders.map(renderOrder))
  if (empty) {
    empty.hidden = matchingOrders.length > 0
    list.append(empty)
  }
  status.textContent = `${matchingOrders.length} matching order${matchingOrders.length === 1 ? "" : "s"}.`
}

const loadOrders = async () => {
  if (!list) return
  refresh.disabled = true
  status.textContent = "Loading recent Shopify orders…"
  try {
    const response = await fetch("/orders.json", {headers: {"Accept": "application/json"}})
    const body = await response.json()
    if (!response.ok) throw new Error(body.error || `Shopify request failed (${response.status})`)
    orders = body
    renderOrders()
  } catch (error) {
    status.textContent = error.message
  } finally {
    refresh.disabled = false
  }
}

refresh?.addEventListener("click", loadOrders)
search?.addEventListener("input", renderOrders)
loadOrders()
